// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2Ay85","sendOtp":"AuthorizeToLogin_sendOtp__1s7S2"};